package com.zq.my_official_website

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.safeContentPadding
import androidx.compose.material3.ExtendedFloatingActionButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp

@Composable
@Preview
fun App() {
    MaterialTheme {
        var page by remember { mutableStateOf(SitePage.Home) }
        var chatVisible by remember { mutableStateOf(false) }

        Box(modifier = Modifier.fillMaxSize()) {
            when (page) {
                SitePage.Home -> HomePage(
                    modifier = Modifier
                        .safeContentPadding()
                        .fillMaxSize(),
                    currentPage = page,
                    onNavigate = { page = it },
                )

                SitePage.Product -> ProductPage(
                    modifier = Modifier
                        .safeContentPadding()
                        .fillMaxSize(),
                    currentPage = page,
                    onNavigate = { page = it },
                )

                SitePage.Plan -> PlanPage(
                    modifier = Modifier
                        .safeContentPadding()
                        .fillMaxSize(),
                    currentPage = page,
                    onNavigate = { page = it },
                )

                SitePage.Partners -> PartnersPage(
                    modifier = Modifier
                        .safeContentPadding()
                        .fillMaxSize(),
                    currentPage = page,
                    onNavigate = { page = it },
                )

                SitePage.About -> AboutPage(
                    modifier = Modifier
                        .safeContentPadding()
                        .fillMaxSize(),
                    currentPage = page,
                    onNavigate = { page = it },
                )
            }

            // 移动端 / 桌面端才渲染联系客服浮动按钮；
            // Web 端由 index.html 的 embed.tawk.to 脚本渲染右下角气泡，避免重复。
            if (isTawkFabVisible) {
                ExtendedFloatingActionButton(
                    onClick = { chatVisible = true },
                    modifier = Modifier
                        .align(Alignment.BottomEnd)
                        .safeContentPadding()
                        .padding(16.dp),
                    text = { Text("联系客服") },
                    icon = { Text("\uD83D\uDCAC") }, // 💬
                )
            }

            TawkChatSheet(
                visible = chatVisible,
                onDismiss = { chatVisible = false },
            )
        }
    }
}
